import { Star } from "lucide-react";
import ReviewsMarquee, {
    REVIEWS_ROW_1,
    REVIEWS_ROW_2,
} from "./ReviewsMarquee";

export default function Reviews() {
    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className="relative py-24 lg:py-32 bg-black overflow-hidden border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-12 lg:mb-16">
                <div className="grid lg:grid-cols-[1fr_auto] gap-10 lg:gap-16 items-end">
                    <div>
                        <div className="eyebrow mb-6">
                            <Star
                                size={11}
                                strokeWidth={0}
                                fill="currentColor"
                                className="text-[#49bef5] drop-shadow-[0_0_6px_rgba(73,190,245,0.8)]"
                            />{" "}
                            Reviews
                        </div>
                        <h2 className="font-display font-bold clamp-h2 text-white">
                            From the people
                            <br />
                            <span className="blue-glow">running it.</span>
                        </h2>
                        <p className="mt-5 text-white/60 text-base lg:text-lg max-w-xl leading-relaxed">
                            App Store, Google Play, every region — pulled
                            together so you can actually see them.
                        </p>
                    </div>

                    {/* Stat strip */}
                    <div
                        className="flex items-stretch gap-0 border border-white/10 rounded-2xl bg-white/[0.02] overflow-hidden self-start lg:self-end max-w-full"
                        data-testid="reviews-stats"
                    >
                        <div className="px-3 sm:px-6 py-4 sm:py-5 text-left">
                            <div className="flex items-center gap-1.5 font-display font-extrabold text-white text-xl sm:text-2xl leading-none">
                                4.5
                                <Star
                                    size={16}
                                    strokeWidth={0}
                                    fill="currentColor"
                                    className="text-[#49bef5] drop-shadow-[0_0_6px_rgba(73,190,245,0.6)]"
                                />
                            </div>
                            <div className="mt-1 text-[10px] uppercase tracking-[0.18em] font-mono text-[#49bef5]">
                                App Store
                            </div>
                        </div>
                        <div className="w-px bg-white/10" />
                        <div className="px-3 sm:px-6 py-4 sm:py-5 text-left">
                            <div className="flex items-center gap-1.5 font-display font-extrabold text-white text-xl sm:text-2xl leading-none">
                                4.5
                                <Star
                                    size={16}
                                    strokeWidth={0}
                                    fill="currentColor"
                                    className="text-[#49bef5] drop-shadow-[0_0_6px_rgba(73,190,245,0.6)]"
                                />
                            </div>
                            <div className="mt-1 text-[10px] uppercase tracking-[0.18em] font-mono text-[#49bef5]">
                                Google Play
                            </div>
                        </div>
                        <div className="w-px bg-white/10" />
                        <div className="px-3 sm:px-6 py-4 sm:py-5 text-left">
                            <div className="font-display font-extrabold text-white text-xl sm:text-2xl leading-none whitespace-nowrap">
                                Cross
                                <span className="text-[#49bef5]">·</span>
                                Platform
                            </div>
                            <div className="mt-1 text-[10px] uppercase tracking-[0.18em] font-mono text-[#49bef5]">
                                Multi-region
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space-y-4">
                <ReviewsMarquee items={REVIEWS_ROW_1} />
                <ReviewsMarquee items={REVIEWS_ROW_2} reverse />
            </div>
        </section>
    );
}
